import ActivitiesApplicationListLayer from "../../components/ActivitiesApplicationListLayer";

const ActivitiesApplicationPage = () => {
  return <ActivitiesApplicationListLayer />;
};

export default ActivitiesApplicationPage;
